import React, { ReactElement, ReactNode } from 'react';
import classNames from 'classnames';
import { Hint } from '@redoc/ui-kit';
import { TreeListInfoItemType } from '.';
import { TreeListInfoItem } from './TreeListInfoItem';
import { Headline } from 'src/UI';
import './TreeListInfo.scss';

interface ITreeListInfoProps extends React.HTMLAttributes<HTMLDivElement> {
	title: string;
	children?: React.ReactNode | React.ReactNode[] | string[];
	items?: Array<TreeListInfoItemType>;
	allowCopy?: boolean;
	renderTb?: () => ReactNode;
}

function check(layer: any): layer is React.FC {
	return !!layer.props;
}

const isValueNotNullOrEmpty = (item: TreeListInfoItemType) => {
	if (!item) {
		return false;
	} else if (item.allowCopy === false) {
		return false;
	} else if (!item.value) {
		return false;
	}
	return !['Не заполнено', 'Совпадает с адресом регистрации'].includes(
		item.value.toString(),
	);
};

export const TreeListInfo: React.FC<ITreeListInfoProps> = ({
	title,
	children,
	allowCopy = true,
	items,
	className,
	renderTb,
	...otherProps
}) => {
	const renderChildren = () => {
		if (!children) {
			return null;
		}
		if (Array.isArray(children) && !!children.length) {
			return children.map((child, index) => {
				return (
					<TreeListInfoItem
						key={'tree-info__item-' + index}
						subTitle=""
						allowCopy={!!child}
					>
						{child}
					</TreeListInfoItem>
				);
			});
		} else if (check(children)) {
			return children;
		} else {
			return (
				<TreeListInfoItem subTitle="" allowCopy={allowCopy}>
					{children}
				</TreeListInfoItem>
			);
		}
	};

	const renderItems = () => {
		if (!!items && !!items.length) {
			return items.map((item, index) => {
				return (
					<TreeListInfoItem
						key={'tree-info__item-' + index}
						subTitle={item.subTitle}
						allowCopy={allowCopy && isValueNotNullOrEmpty(item)}
					>
						{item.children ? item.children : item.value || ''}
					</TreeListInfoItem>
				);
			});
		}
	};

	return (
		<div className={classNames('tree-info', className)} {...otherProps}>
			<div className="tree-info__header">
				<Headline className="tree-info__title" title={title}>
					{title}
				</Headline>
				{!!renderTb && (
					<Hint placement="top" messageText="Редактировать блок">
						{renderTb() as ReactElement}
					</Hint>
				)}
			</div>
			<ul className="tree-info__list body-small">
				<>
					{renderChildren()}
					{renderItems()}
				</>
			</ul>
		</div>
	);
};
